import { GLOBAL_CONSTANTS } from "../../constants";

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

// 🔹 Главная функция для расчета доставки нерудки
export const calculateDeliveryCostNonmetallic = async (materials, deliveryMethod, productionInfo, selfPickUp, addressAndCoordinates, selectedRegion, paymentMethod, signal) => {
  console.log("⛏️ calculateDeliveryCostNonmetallic: Начинаем расчет доставки для нерудки");
  console.log("⛏️ materials:", materials);
  console.log("⛏️ deliveryMethod:", deliveryMethod);
  console.log("⛏️ paymentMethod:", paymentMethod);

  try {
    const result = await processNerCategoryNonmetallic(materials, deliveryMethod, productionInfo, selfPickUp, addressAndCoordinates, selectedRegion, paymentMethod, signal);
    return {
      ner: result
    };
  } catch (error) {
    if (error?.name === "AbortError") {
      throw error;
    }
    console.error("❌ Ошибка при расчете доставки нерудки:", error);
    return {
      ner: {
        category: "Нерудные материалы",
        details: { error: "Ошибка при расчете доставки" }
      }
    };
  }
};

// Керамзит считается по своей формуле (routes/deliveryKeramzitCalculator.js), а не
// по общей нерудной B46-формуле — у него отдельные правила доставки по ТЗ.
const KERAMZIT_CATEGORIES = new Set([
  "Керамзит навалом",
  "Керамзит в мешках",
  "Керамзит в Биг-Бэгах",
]);

const processKeramzitCategoryNonmetallic = async (materials, productionInfo, addressAndCoordinates, selectedRegion, category, totalVolume, signal) => {
  const production = productionInfo?.NAME || materials[0]?.manufacturer;
  if (!production) {
    return { category: "Нерудные материалы", details: { error: "Не определено производство" }, error: true };
  }

  const updatedAddressAndCoordinates = {
    ...addressAndCoordinates,
    region: selectedRegion,
  };

  // Количество единиц товара (мешков) — сервер считает по нему рейсы там, где
  // вместимость машины задана не в кубах: мешки из Калуги едут кратно фуре.
  const orderQuantity = materials.reduce((acc, material) => acc + (Number(material.quantity) || 0), 0);

  // Названия позиций — из них сервер берёт фракцию керамзита (0-5/5-10/10-20/20-40 мм),
  // по которой в keramzit_loading_norms задана норма погрузки: в машину влезает тем
  // меньше товара, чем мельче фракция. Отдельного поля под фракцию в прайсе нет.
  const nomenclatures = materials.map((material) => material.name).filter(Boolean);

  const response = await fetch(`${PATH_TO_BACKEND}/api/delivery_keramzit`, {
    signal,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      category,
      production,
      orderVolume: totalVolume,
      orderQuantity,
      nomenclatures,
      addressAndCoordinates: updatedAddressAndCoordinates,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    return {
      category: "Нерудные материалы",
      details: { error: data.error || "Не удалось рассчитать доставку керамзита" },
      error: true,
    };
  }

  console.log(`✅ Ответ от /api/delivery_keramzit:`, data);
  return { category: "Нерудные материалы", details: data };
};

// 🔹 Обработка категории нерудки (адаптированная версия)
const processNerCategoryNonmetallic = async (materials, deliveryMethod, productionInfo, selfPickUp, addressAndCoordinates, selectedRegion, paymentMethod, signal) => {
  console.log("⛏️ Обработка категории 'Нерудные материалы' (специализированная версия):", materials);

  const totalVolume = materials.reduce((acc, material) => {
    const quantity = Number(material.quantity) || 0;
    const volumePerOne = Number((material.volumePerOne || "").toString().replace(",", ".")) || 0;
    const itemVolume = quantity * volumePerOne;
    console.log(`📦 Товар: ${material.name}, Количество: ${quantity}, Объём за единицу: ${volumePerOne}, Общий объём товара: ${itemVolume}`);
    return acc + itemVolume;
  }, 0);

  console.log(`📦 Итоговый объём для нерудки: ${totalVolume} м³`);
  console.log(`💳 Способ оплаты: ${paymentMethod}`);

  if (!addressAndCoordinates) {
    console.error("❌ Ошибка: Координаты клиента не переданы!");
    return { category: "Нерудные материалы", details: { error: "Координаты клиента отсутствуют" } };
  }

  // Определяем категорию материала из первого товара
  const materialCategory = materials[0]?.category || "Песок";
  console.log(`📦 Категория материала: ${materialCategory}`);

  if (KERAMZIT_CATEGORIES.has(materialCategory)) {
    return processKeramzitCategoryNonmetallic(materials, productionInfo, addressAndCoordinates, selectedRegion, materialCategory, totalVolume, signal);
  }

  try {
    // Добавляем selectedRegion в addressAndCoordinates для передачи на сервер
    const updatedAddressAndCoordinates = {
      ...addressAndCoordinates,
      region: selectedRegion,
    };

    const response = await fetch(`${PATH_TO_BACKEND}/api/delivery_ner`, {
      signal,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        materials,
        deliveryMethod: typeof deliveryMethod === 'string' ? deliveryMethod : (deliveryMethod?.ner || "Оптимальный маршрут"),
        addressAndCoordinates: updatedAddressAndCoordinates,
        productionInfo,
        paymentMethod,
        category: materialCategory,
        // Добавляем флаг специализированного режима
        specializedMode: true
      }),
    });

    if (!response.ok) {
      const data = await response.json();

      switch (response.status) {
        case 400:
          return {
            category: "Нерудные материалы",
            details: { error: data.error || "Не хватает данных для расчета доставки" },
            error: true
          };
        case 422:
          return {
            category: "Нерудные материалы",
            details: { error: data.error || "Проверьте корректность введенных данных" },
            error: true
          };
        case 502:
          return {
            category: "Нерудные материалы",
            details: { error: data.error || "Техническая ошибка. Сообщите в поддержку." },
            error: true
          };
        case 500:
        default:
          return {
            category: "Нерудные материалы",
            details: { error: data.error || "Техническая ошибка. Сообщите в поддержку." },
            error: true
          };
      }
    }

    const data = await response.json();
    console.log(`✅ Ответ от /api/delivery_ner (специализированный):`, data);
    return { category: "Нерудные материалы", details: data };
  } catch (error) {
    if (error?.name === "AbortError") {
      throw error;
    }
    console.error("❌ Ошибка при расчете доставки нерудки:", error);

    // Проверяем, не вернулась ли уже ошибка с деталями
    if (error?.details?.error) {
      return { ner: error };
    }

    return {
      ner: {
        category: "Нерудные материалы",
        details: { error: "Ошибка при расчете доставки" },
        error: true
      }
    };
  }
};
